(function () {
  const MONTHS = 6;
  const fmt = new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON' });

  const PRICE_SELECTOR = '.tpo_product_price, .price__current, .price';
  const QTY_SELECTOR     = '.quantity-selector__value';
  const SECTION_SELECTOR = '[data-section-type="product"]';

  const ADDON_ITEM_SELECTOR  = 'lb-upsell-long-card';
  const ADDON_PRICE_SELECTOR = 'lb-price';

  function parsePrice(text) {
    const cleaned = text.replace(/[^\d.,]/g, '').replace(/\./g, '').replace(',', '.');
    return parseFloat(cleaned) || 0;
  }

  function getRoot() {
    return document.querySelector(SECTION_SELECTOR) || document.body;
  }

  function getQty() {
    const root = getRoot();
    const el = root.querySelector(QTY_SELECTOR) || root.querySelector('[name="quantity"]');
    if (!el) return 1;
    const q = parseInt(el.value ?? el.textContent, 10);
    return isNaN(q) || q < 1 ? 1 : q;
  }

  function isAddonSelected(item) {
    const cb = item.querySelector('input.lb-card-checkbox');
    if (cb) return cb.checked;
    return item.hasAttribute('lb-selected');
  }

  function getAddonQty(item) {
    const qtyEl = item.querySelector('input[type="number"], .lb-qty input');
    return qtyEl ? (parseInt(qtyEl.value ?? qtyEl.textContent, 10) || 1) : 1;
  }

  function getAddonsTotal() {
    let total = 0;
    document.querySelectorAll(ADDON_ITEM_SELECTOR).forEach((item) => {
      if (!isAddonSelected(item)) return;
      const priceEl = item.querySelector(ADDON_PRICE_SELECTOR);
      if (priceEl) total += parsePrice(priceEl.textContent) * getAddonQty(item);
    });
    return total;
  }

  function render() {
    const root = getRoot();
    const box = root.querySelector('.installment-guide');
    const priceEl = root.querySelector(PRICE_SELECTOR);
    if (!box || !priceEl) return;

    const subtotal = parsePrice(priceEl.textContent) * getQty() + getAddonsTotal();
    const monthly = subtotal / MONTHS;

    const out = box.querySelector('.installment-guide__amount');
    const next = fmt.format(monthly);
    if (out && out.textContent !== next) out.textContent = next;
  }

  // Observă doar elementul de preț, nu întreaga secțiune
  function observePrice() {
    const root = getRoot();
    const priceEl = root.querySelector(PRICE_SELECTOR);
    if (!priceEl) return;

    let lastText = priceEl.textContent;
    let debounceTimer = null;

    new MutationObserver(function() {
      const currentText = priceEl.textContent;
      if (currentText === lastText) return; // nicio schimbare reală
      lastText = currentText;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(render, 50); // 50ms doar ca să termine Focal de scris
    }).observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  function init() {
    render();
    const root = getRoot();

    // Ascultă evenimentele Focal de variant change
    ['variant:change', 'variant:changed', 'on:variant:change'].forEach(function(evtName) {
      root.addEventListener(evtName, render);
      document.addEventListener(evtName, render);
    });

    // Observă doar elementul de preț (nu toată secțiunea)
    observePrice();

    root.addEventListener('input',  (e) => { if (e.target.matches(QTY_SELECTOR)) render(); });
    root.addEventListener('change', (e) => { if (e.target.matches(QTY_SELECTOR)) render(); });
    root.addEventListener('click', () => setTimeout(render, 50));

    const upsell = document.querySelector('lb-upsell-widget');
    if (upsell) {
      upsell.addEventListener('change', render);
      upsell.addEventListener('click', () => setTimeout(render, 50));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();